﻿$.fn.dxCtrlBuilderEmailStyleColonneCouleur = function custom_dxCtrlBuilderEmailStyleColonneCouleur(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailstylecolonnecouleur dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailStyleColonneCouleur(this, option));
    }
    return this;
}

window.cdxCtrlBuilderEmailStyleColonneCouleur = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.css("height", ((container.innerHeight() > 0) ? container.innerHeight() + "px" : ""))
        container.empty();

        var lstEle = []
        option.value.find(".colonne").each(function (idx, eleBloc) {
            lstEle.push({
                idx: idx,
                eleBloc: $(eleBloc)
            })
        })
        lstEle.forEach(function (itemData, idx) {
            $("<div  style='margin:5px 0;'/>").appendTo(container).dxCtrlColorPicker({
                value: itemData.eleBloc.css("background-color"),
                title: "Couleur colonne " + (idx + 1),
                titlePaletteSelect: "Couleur dans votre email",
                getPaletteSelect: option.dxBuilderEmailPage.mGetLstColor,
                onValueChanged: function (e) {
                    itemData.eleBloc.css("background-color", e.value)
                }
            })
        })

        container.css("height", "")
    }

    this.element = function () { return container }

    mConstruit();
}